import AbstractHtmlConstructorType
    from "~/cabinet/vue/interface/htmlConstructor/constructorType/AbstractHtmlConstructorType";
import {IHtmlConstructorBlock} from "~/cabinet/vue/interface/htmlConstructor/Interface";
import {HTML_BLOCK_TYPE_TEXT} from "~/cabinet/vue/interface/htmlConstructor/blocks/Constants";
import KnowledgeBaseHtmlContentDisplay
    from "~/cabinet/vue/interface/htmlConstructor/constructorType/knowledgeBase/KnowledgeBaseHtmlContentDisplay.vue";
import {RawComponent, useRawComponent} from "~/core-ui/ts/useRawComponent";

export default class KnowledgeBaseHtmlConstructorType extends AbstractHtmlConstructorType {
    get contentDisplayComponent(): RawComponent {
        return useRawComponent(KnowledgeBaseHtmlContentDisplay);
    }

    getDefaultBlockLists(): IHtmlConstructorBlock<any>[] {
        return [
            {
                type: HTML_BLOCK_TYPE_TEXT,
                values: {}
            }
        ];
    }

    get isStyleEditableInContentEditor(): boolean {
        return false;
    }
}